export default "/public/app-main/static/image/64af78755a34a35406e3847b3bf45808.png";